interface Quote {
  text: string;
  stat: string;
  author: string;
  bg: string;
  fg: string;
}

const QUOTES: Quote[] = [
  {
    text: "Video #4 hit 210K views. I didn't film a single second. I just uploaded my photo and let Dualio do the rest.",
    stat: "210K views",
    author: "Jake · Dropshipper",
    bg: "#c4b5fd",
    fg: "#7c3aed",
  },
  {
    text: "I used to delete every video I recorded. Now I post every day. My Etsy shop traffic is up 3x since I started.",
    stat: "3× store traffic",
    author: "Morgan · Etsy seller",
    bg: "#fde68a",
    fg: "#d97706",
  },
];

const QuoteAvatar = ({ bg, fg }: { bg: string; fg: string }) => (
  <svg
    viewBox="0 0 36 36"
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    aria-hidden="true"
  >
    <rect width="36" height="36" fill={bg} />
    <circle cx="18" cy="14" r="7" fill={fg} />
    <ellipse cx="18" cy="30" rx="11" ry="8" fill={fg} />
  </svg>
);

const SocialProof = () => (
  <section className="mx-auto mt-16 max-w-4xl px-4 sm:px-6">
    <p className="mb-6 text-center font-semibold text-xs text-zinc-500 uppercase tracking-widest">
      What creators are saying
    </p>
    <div className="grid gap-4 sm:grid-cols-2">
      {QUOTES.map((q) => (
        <div
          key={q.author}
          className="relative rounded-2xl border border-brown-200 bg-white p-7"
        >
          <span
            aria-hidden="true"
            className="absolute top-4 left-6 font-serif text-5xl text-primary/30 leading-none"
          >
            "
          </span>
          <p className="mb-4 pt-2 font-medium text-[15px] text-zinc-900 leading-relaxed">
            {q.text}
          </p>
          <p className="mb-1 font-extrabold text-2xl text-primary">{q.stat}</p>
          <div className="flex items-center gap-2.5">
            <div className="h-9 w-9 overflow-hidden rounded-full">
              <QuoteAvatar bg={q.bg} fg={q.fg} />
            </div>
            <p className="font-medium text-sm text-zinc-500">{q.author}</p>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default SocialProof;
